import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { makeRequest } from '@/services/makeRequest';
import {
	getSeoContent,
	setSeoContent,
	setSeoDescription,
	setSeoTitle,
} from '@/stores/slices/titleSlice';
import { useDispatch, useSelector } from 'react-redux';
import baseUrl from '@/services/apiConfig';
import useLadyService from '@/services/LadyService';
import axios from 'axios';

const SEOBlock = ({ }) => {
	const location = useLocation();
	const pageSlug = location?.pathname
		.replace(baseUrl, '')
		.replace(/^\/(en|cz|ru|de|sk)/, '');
	const dispatch = useDispatch();
	const seoContent = useSelector(getSeoContent);
	const params = useParams();

	const { lang } = useLadyService();

	const url_lang = params.lang;

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	const [isReady, setIsReady] = useState(false);

	const fetchData = async () => {
		const route = `static${pageSlug !== '/' && pageSlug !== '/czechia' ? pageSlug : '/home'}`;
		const method = 'GET';
		const token = localStorage.getItem('user');

		const axiosConfig = {
			method,
			url: `${baseUrl}${route}?lang=${url_lang || lang}`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};

		axios(axiosConfig)
			.then(async (res) => {
				const { data } = res;
				console.log(
					`SEO CONTENT FOR ${route.replace('static', '')} AND LANG ${url_lang || lang}`,
				);
				dispatch(setSeoContent(data?.content));
				dispatch(setSeoTitle(data?.seo_title));
				dispatch(setSeoDescription(data?.seo_description));
			})
			.catch((error) => {
				if (error.response) {
					if (error.response.status === 401) {
						localStorage.removeItem('user');
					} else if (error.response.status === 404) {
						console.warn('SEO content not found for this route');
						dispatch(setSeoTitle(false));
						dispatch(setSeoDescription(false));
						dispatch(setSeoContent(false));
					} else throw error;
				}
			});

		// deprecated cause of the lang mismatch
		// makeRequest({ route, method })
		// 	.then((response) => {
		// 		if (response) {
		// 			dispatch(setSeoContent(response?.content));
		// 			dispatch(setSeoTitle(response?.seo_title));
		// 			dispatch(setSeoDescription(response?.seo_description));
		// 		} else {
		// 			throw new Error('no seo response');
		// 		}
		// 	})
		// 	.catch((err) => {
		// 		console.error(err);
		// 		dispatch(setSeoTitle(false));
		// 		dispatch(setSeoDescription(false));
		// 		dispatch(setSeoContent(false));
		// 	});
	};

	useEffect(() => {
		if (!isReady) return;
		fetchData();
	}, [location, isReady]);

	// Ждём стабилизации роута (pathname не меняется 100мс)
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setIsReady(true);
		}, 100);

		return () => clearTimeout(timeoutId);
	}, [location.pathname]);

	return (
		<>
			{seoContent && (
				<div
					className="container w-100 gap-0"
					dangerouslySetInnerHTML={{ __html: seoContent }}
				></div>
			)}
			{!isJsdom &&
				(location.pathname === `/${lang}/czechia` ||
					location.pathname === '/') && (<div className="container w-100 gap-0">

						<p>
							<a
								href={`/${lang}/links`}
								style={{ marginRight: '4px' }}
							>
								{lang === 'cz' && <>Naši partneři.</>}
								{lang === 'ru' && <>Наши партнёры.</>}
								{lang === 'en' && <>Our partners.&nbsp;</>}
								{lang === 'de' && <>Unsere Partner.</>}
								{lang === 'sk' && <>Naši partneri.</>}

							</a>
						</p>

					</div>)}
		</>
	);
};

export default SEOBlock;
